import {getConfig} from '../../services/config/configService';

const getAssets = (assetsPageName) => getConfig()?.assets?.[assetsPageName];

const configAppGetters = {
    getAssets,
};

export default configAppGetters;
